export default __webpack_public_path__ + "static/media/pakkapati 3.550b9020.PNG";